var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"none-content"},[_c('img',{staticClass:"noImg",attrs:{"src":require("@/assets/none-icon.png")}}),_c('div',{staticClass:"none-content-label"},[_vm._v("暂无内容")])])
}]

export { render, staticRenderFns }